import Vue from 'vue';
import vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

Vue.use(vuex);
const store = new vuex.Store({
	state: {
		endpoint:'https://api.figaro.hr/api/',
		// endpoint: 'http://127.0.0.1:8000/api/',
		notification: {
			type: 0,
			message: ''
		},
		loader: false,
		image_viewer: false,
		active_image: 0,
		user: null,
		token: null,
		home_picture: "",
		profile_picture: "",
		featured_picture: [],
		featured_salons: [],
		home_salons: [],
		salons: [],
		salon: null,
		photos: [],
		booking_head: [],
		booking_body: [],
		comments: [],
		stats: [],
		saleServices: []
	},
	actions,
	mutations
});


export default store;
